import React, { useState, useEffect } from "react";
// import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faEdit,
  faTrash,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import axiosClient from "../../../axios-client";
import { useNavigate } from "react-router-dom";

const PlanModal = ({ type, onClose, planId, selectedPlanData, onSuccess }) => {
  const createdBy = localStorage.getItem("userId");
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(selectedPlanData || null);
  const [isEditing, setIsEditing] = useState(type === "edit");
  const [updatedPlan, setUpdatedPlan] = useState(selectedPlanData || {});
  const navigate = useNavigate();

  useEffect(() => {
    if (selectedPlanData) {
      setSelectedPlan(selectedPlanData);
      setUpdatedPlan(selectedPlanData);
      setIsEditing(type === "edit");
    }
  }, [selectedPlanData, type]);

  const adminID = localStorage.getItem("Admin_id");
  const [formData, setFormData] = useState({
    name: "",
    category: "",
    price: "",
    billingCycle: "",
    features: {
      globalMarketStatistics: false,
      RegionAndCountriesMarketStatistics: false,
      premiumStatisticsAccess: "",
      reportDownloads: "",
      memberReportPrice: "",
      graphDownloadLimit: "",
      graphDownloadFormats: [],
      onDemandReportsCredits: "",
      newsletters: false,
      industryAnalysisReports: false,
      customizationHours: "",
      consultationHours: "",
      pricingIndicesAccess: false,
      companyProfilesAccess: false,
      useCasesAccess: false,
      customerService: "",
      dataCitationLicense: false,
    },
    isCustomizable: false,
    createdBy: adminID,
  });

  useEffect(() => {
    const adminToken = localStorage.getItem("Admin_Token");
    if (!adminToken) {
      navigate("/admin/login");
    }
  }, [navigate]);
  useEffect(() => {
    if (type === "get") {
      axiosClient
        .get("/plans/getall")
        .then((response) => setPlans(response.data.plans))
        .catch((error) => console.error("Error fetching plans:", error));
    }
  }, [type]);

  const handleViewDetails = (plan) => {
    setSelectedPlan(plan);
    setUpdatedPlan(plan); // Initialize update fields
    setIsEditing(false);
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setUpdatedPlan((prevPlan) => ({
      ...prevPlan,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFeatureChange = (e) => {
    const { name, value, type, checked, options } = e.target;
    let newValue;

    if (name === "graphDownloadFormats") {
      newValue = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
    } else {
      newValue = type === "checkbox" ? checked : value;
    }
    setUpdatedPlan((prevPlan) => ({
      ...prevPlan,
      features: {
        ...prevPlan.features,
        [name]: newValue,
      },
    }));
  };

  const handleUpdate = async () => {
    if (!selectedPlan?._id) {
      return;
    }
    try {
      await axiosClient.put(
        `/plans/updateplan/${selectedPlan._id}`,
        updatedPlan
      );
      alert("Plan updated successfully!");
      setIsEditing(false);
      setSelectedPlan(updatedPlan); // Update the view with new details
      if (onSuccess) onSuccess();
      onClose();
    } catch (error) {
      console.error("Error updating plan:", error);
      alert("Failed to update plan.");
    }
  };

  const handleDelete = async (planId) => {
    try {
      await axiosClient.delete(`/plans/delete/plan/${planId}`);
      alert("Plan deleted successfully!");
      setPlans((prevPlans) => prevPlans.filter((plan) => plan._id !== planId));
      if (onSuccess) onSuccess();
      onClose();
    } catch (error) {
      console.error("Error deleting plan:", error);
      alert("Failed to delete plan.");
    }
  };

  const handleFormInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name in formData.features) {
      setFormData({
        ...formData,
        features: {
          ...formData.features,
          [name]: type === "checkbox" ? checked : value,
        },
      });
    } else {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value,
      });
    }
  };
  const handleFormCheckboxChange = (e) => {
    const { name, checked } = e.target;
    let updatedFormats = [...formData.features.graphDownloadFormats];

    if (name === "Both") {
      if (checked) {
        updatedFormats = ["PNG", "XLS"];
      } else {
        updatedFormats = updatedFormats.filter(
          (format) => format !== "PNG" && format !== "XLS"
        );
      }
    } else {
      if (checked) {
        updatedFormats.push(name);
      } else {
        updatedFormats = updatedFormats.filter((format) => format !== name);
      }
    }

    setFormData({
      ...formData,
      features: {
        ...formData.features,
        graphDownloadFormats: updatedFormats,
      },
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosClient.post("/plans/create", formData);
      console.log("Form data:", formData);
      console.log("Response:", response.data);
      if (response.data.success === true) {
        alert("Plan created successfully!");
        if (onSuccess) onSuccess();
        onClose();
      }
    } catch (error) {
      console.error("Error creating plan:", error);
      alert(error.response?.data?.message || "Failed to create plan.");
    }
  };
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100]">
      {/* <div className="bg-white p-6 rounded-lg shadow-lg max-w-2xl w-full h-auto max-h-screen overflow-y-auto relative"> */}
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-4xl w-full h-auto max-h-screen overflow-y-auto relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>

        {type === "get" && (
          <div>
            <h2 className="text-xl font-bold mb-4">All Plans</h2>
            <table className="min-w-full bg-white border">
              <thead>
                <tr>
                  <th className="py-2 px-4  border-b">Plan Name</th>
                  <th className="py-2 px-4  border-b">Price</th>
                  <th className="py-2 px-4 pr-32 border-b">Actions</th>
                </tr>
              </thead>
              <tbody>
                {plans.map((plan) => (
                  <tr key={plan._id}>
                    <td className="py-2 px-4  border-b">{plan.name}</td>
                    <td className="py-2 px-4  border-b">${plan.price}</td>
                    <td className="py-2 px-4  border-b flex space-x-2">
                      <button
                        onClick={() => handleViewDetails(plan)}
                        className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                      >
                        <FontAwesomeIcon icon={faEye} className="mr-1" />
                        View Details
                      </button>
                      <button
                        onClick={() => {
                          handleViewDetails(plan);
                          handleEdit();
                        }}
                        className="bg-yellow-500 nopaddingSvg text-white px-3 py-1 rounded hover:bg-yellow-600"
                      >
                        <FontAwesomeIcon
                          icon={faEdit}
                          className="mr-1  p-[0px]"
                        />
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(plan._id)}
                        className="bg-red-500 nopaddingSvg text-white px-3 py-1 rounded hover:bg-red-600"
                      >
                        <FontAwesomeIcon
                          icon={faTrash}
                          className="mr-1 p-[0px]"
                        />
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {selectedPlan && !isEditing && (
          <div className="mt-6">
            <h2 className="text-xl font-bold mb-4">
              Plan Details: {selectedPlan.name}
            </h2>
            <p>
              <strong>Price:</strong> ${selectedPlan.price}
            </p>
            <p>
              <strong>Billing Cycle:</strong> {selectedPlan.billingCycle}
            </p>
            <p>
              <strong>Customizable:</strong>{" "}
              {selectedPlan.isCustomizable ? "Yes" : "No"}
            </p>

            <h3 className="text-lg font-semibold mt-4">Features:</h3>
            <ul className="list-disc list-inside mt-2">
              {Object.entries(selectedPlan.features || {}).map(([key, value]) => (
                <li key={key}>
                  <strong>{key}:</strong>{" "}
                  {typeof value === "boolean" ? (value ? "Yes" : "No") : value}
                </li>
              ))}
            </ul>
          </div>
        )}

        {isEditing && (
          <div className="mt-6">
            <h2 className="text-xl font-bold mb-4">
              Edit Plan: {updatedPlan.name}
            </h2>
            <label>
              Price:
              <input
                type="number"
                name="price"
                value={updatedPlan.price}
                onChange={handleInputChange}
                className="w-full p-2 mt-2 border rounded"
              />
            </label>

            <label>
              Billing Cycle:
              <select
                name="billingCycle"
                value={updatedPlan.billingCycle}
                onChange={handleInputChange}
                className="w-full p-2 mt-2 border rounded"
              >
                <option value="monthly">Monthly</option>
                <option value="annually">Annually</option>
              </select>
            </label>

            <label>
              Customizable:
              <input
                type="checkbox"
                name="isCustomizable"
                checked={updatedPlan.isCustomizable}
                onChange={handleInputChange}
                className="ml-2"
              />
            </label>

            <h3 className="text-lg font-semibold mt-4">Edit Features:</h3>
            {Object.keys(updatedPlan.features || {}).map((featureKey) => (
              <label key={featureKey} className="block mt-2">
                {featureKey}:
                {featureKey === "graphDownloadFormats" ? (
                  <select
                    name={featureKey}
                    value={updatedPlan.features[featureKey] || []}
                    onChange={handleFeatureChange}
                    className="ml-2"
                  >
                    <option value="">Select Format</option>
                    <option value="PNG">PNG</option>
                    <option value="XLS">XLS</option>
                    <option value={"PNG, XLS"}>XLS PNG</option>
                  </select>
                ) : (
                  <input
                    type={
                      typeof updatedPlan.features[featureKey] === "boolean"
                        ? "checkbox"
                        : "number"
                    }
                    name={featureKey}
                    checked={
                      typeof updatedPlan.features[featureKey] === "boolean"
                        ? updatedPlan.features[featureKey]
                        : undefined
                    }
                    value={
                      typeof updatedPlan.features[featureKey] === "number"
                        ? updatedPlan.features[featureKey]
                        : undefined
                    }
                    onChange={handleFeatureChange}
                    className="ml-2"
                  />
                )}
              </label>
            ))}
            <button
              onClick={handleUpdate}
              className="bg-green-500 text-white px-4 py-2 rounded mt-4 hover:bg-green-600"
            >
              Save Changes
            </button>
          </div>
        )}
        {type === "create" && (
          <div>
            <h2 className="text-2xl font-bold mb-4">Create Plan</h2>
            <form onSubmit={handleFormSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Name:
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleFormInputChange}
                    className="mt-1 block w-full p-2 border rounded"
                  />
                </label>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Category:
                  <select
                    name="category"
                    value={formData.category}
                    onChange={handleFormInputChange}
                    className="mt-1 block w-full p-2 border rounded"
                  >
                    <option value="">Select a category</option>
                    {/* <option value="Freemium">Free Plan</option> */}
                    <option value="Starter">Starter Plan</option>
                    <option value="Premium">Premium Plan</option>
                    <option value="Enterprise">Enterprise Plan</option>
                  </select>
                </label>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Price:
                  <input
                    type="number"
                    name="price"
                    value={formData.price}
                    onChange={handleFormInputChange}
                    className="mt-1 block w-full p-2 border rounded"
                    min="0"
                  />
                </label>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Billing Cycle:
                  <select
                    name="billingCycle"
                    value={formData.billingCycle}
                    onChange={handleFormInputChange}
                    className="mt-1 block w-full p-2 border rounded"
                  >
                    <option value="">Select a billing cycle</option>
                    <option value="annually">Annually</option>
                    <option value="monthly">Monthly</option>
                  </select>
                </label>
              </div>
              <p className="text-lg font-semibold mt-4">Features:</p>
              <div className="space-y-4">
                <label className="block text-sm font-medium text-gray-700">
                  Global Market Statistics:
                  <input
                    type="checkbox"
                    name="globalMarketStatistics"
                    checked={formData.features.globalMarketStatistics}
                    onChange={handleFormInputChange}
                    className="ml-2"
                  />
                </label>
                <label className="block text-sm font-medium text-gray-700">
                  Access to Regional & Country Level Market Statistics:
                  <input
                    type="checkbox"
                    name="RegionAndCountriesMarketStatistics"
                    checked={
                      formData.features.RegionAndCountriesMarketStatistics
                    }
                    onChange={handleFormInputChange}
                    className="ml-2"
                  />
                </label>
                <label className="block text-sm font-medium text-gray-700">
                  Premium Statistics Access:
                  <input
                    type="number"
                    name="premiumStatisticsAccess"
                    value={formData.features.premiumStatisticsAccess}
                    onChange={handleFormInputChange}
                    className="mt-1 block w-full p-2 border rounded"
                    min="0"
                  />
                </label>
                <label className="block text-sm font-medium text-gray-700">
                  Report Downloads:
                  <input
                    type="number"
                    name="reportDownloads"
                    value={formData.features.reportDownloads}
                    onChange={handleFormInputChange}
                    className="mt-1 block w-full p-2 border rounded"
                    min="0"
                  />
                </label>
                <label className="block text-sm font-medium text-gray-700">
                  Member Report Price:
                  <input
                    type="number"
                    name="memberReportPrice"
                    value={formData.features.memberReportPrice}
                    onChange={handleFormInputChange}
                    className="mt-1 block w-full p-2 border rounded"
                    min="0"
                  />
                </label>
                <label className="block text-sm font-medium text-gray-700">
                  Graph Download Limit:
                  <input
                    type="number"
                    name="graphDownloadLimit"
                    value={formData.features.graphDownloadLimit}
                    onChange={handleFormInputChange}
                    className="mt-1 block w-full p-2 border rounded"
                    min="0"
                  />
                </label>
                <label className="block text-sm font-medium text-gray-700">
                  Graph Download Formats:
                  <div className="ml-2 space-y-2">
                    <label className="inline-flex items-center">
                      <input
                        type="checkbox"
                        name="PNG"
                        checked={formData.features.graphDownloadFormats.includes(
                          "PNG"
                        )}
                        onChange={handleFormCheckboxChange}
                      />
                      <span className="ml-2">PNG</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="checkbox"
                        name="XLS"
                        checked={formData.features.graphDownloadFormats.includes(
                          "XLS"
                        )}
                        onChange={handleFormCheckboxChange}
                      />
                      <span className="ml-2">XLS</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="checkbox"
                        name="Both"
                        checked={
                          formData.features.graphDownloadFormats.includes(
                            "PNG"
                          ) &&
                          formData.features.graphDownloadFormats.includes("XLS")
                        }
                        onChange={handleFormCheckboxChange}
                      />
                      <span className="ml-2">Both</span>
                    </label>
                  </div>
                </label>
                <label className="block text-sm font-medium text-gray-700">
                  On-Demand Reports Credits:
                  <input
                    type="number"
                    name="onDemandReportsCredits"
                    value={formData.features.onDemandReportsCredits}
                    onChange={handleFormInputChange}
                    className="mt-1 block w-full p-2 border rounded"
                    min="0"
                  />
                </label>
                <label className="block text-sm font-medium text-gray-700">
                  Newsletters:
                  <input
                    type="checkbox"
                    name="newsletters"
                    checked={formData.features.newsletters}
                    onChange={handleFormInputChange}
                    className="ml-2"
                  />
                </label>
                <label className="block text-sm font-medium text-gray-700">
                  Industry Analysis Reports:
                  <input
                    type="checkbox"
                    name="industryAnalysisReports"
                    checked={formData.features.industryAnalysisReports}
                    onChange={handleFormInputChange}
                    className="ml-2"
                  />
                </label>
                <label className="block text-sm font-medium text-gray-700">
                  Customization Hours:
                  <input
                    type="number"
                    name="customizationHours"
                    value={formData.features.customizationHours}
                    onChange={handleFormInputChange}
                    className="mt-1 block w-full p-2 border rounded"
                    min="0"
                  />
                </label>
                <label className="block text-sm font-medium text-gray-700">
                  Consultation Hours:
                  <input
                    type="number"
                    name="consultationHours"
                    value={formData.features.consultationHours}
                    onChange={handleFormInputChange}
                    className="mt-1 block w-full p-2 border rounded"
                    min="0"
                  />
                </label>
                <label className="block text-sm font-medium text-gray-700">
                  Pricing Indices Access:
                  <input
                    type="checkbox"
                    name="pricingIndicesAccess"
                    checked={formData.features.pricingIndicesAccess}
                    onChange={handleFormInputChange}
                    className="ml-2"
                  />
                </label>
                <label className="block text-sm font-medium text-gray-700">
                  Company Profiles Access:
                  <input
                    type="checkbox"
                    name="companyProfilesAccess"
                    checked={formData.features.companyProfilesAccess}
                    onChange={handleFormInputChange}
                    className="ml-2"
                  />
                </label>
                <label className="block text-sm font-medium text-gray-700">
                  Use Cases Access:
                  <input
                    type="checkbox"
                    name="useCasesAccess"
                    checked={formData.features.useCasesAccess}
                    onChange={handleFormInputChange}
                    className="ml-2"
                  />
                </label>
                <label className="block text-sm font-medium text-gray-700">
                  Customer Service:
                  <select
                    name="customerService"
                    value={formData.features.customerService}
                    onChange={handleFormInputChange}
                    className="mt-1 block w-full p-2 border rounded"
                  >
                    <option value="">Select a customer service option</option>
                    <option value="24*5">24*5</option>
                    <option value="24*7">24*7</option>
                  </select>
                </label>
                <label className="block text-sm font-medium text-gray-700">
                  Data Citation License:
                  <input
                    type="checkbox"
                    name="dataCitationLicense"
                    checked={formData.features.dataCitationLicense}
                    onChange={handleFormInputChange}
                    className="ml-2"
                  />
                </label>
              </div>
              <button
                type="submit"
                className="bg-green-500 text-white px-4 py-2 rounded mt-4 hover:bg-green-600"
              >
                Save Plan
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default PlanModal;
